import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DesktopNav = () => {
  const { t } = useTranslation();
  
  const linkClass = "text-slate-600 hover:text-blue-600 font-extrabold text-[13px] px-3.5 py-2 transition-colors duration-200 no-underline select-none";
  const activeClass = "text-blue-600 font-extrabold  border-1 border-blue-600 rounded-[12px]";
  
  return (
    <div className="flex items-center gap-0.5">
      <NavLink 
        to="/courses"
        className={({ isActive }) => `${linkClass} ${isActive ? activeClass : ""}`} 
        
      >
        {t("All Courses")}
      </NavLink>
      <NavLink 
        to="/becomeaninstructor"
        className={({ isActive }) => `${linkClass} ${isActive ? activeClass : ""}`} 
      >
        {t("Become an Instructor")}
      </NavLink>
      <NavLink 
        to="/forbusiness"
        className={({ isActive }) => `${linkClass} ${isActive ? activeClass : ""}`} 
      >
        {t("For Business")}
      </NavLink>
      {/* <a 
        href="https://blog.smiklearn.com/" 
        target="_blank" 
        rel="noopener noreferrer"
        className={linkClass}
      >
        {t("Blog")}
      </a> */}
      <NavLink
        to="/jobs"
        className={({ isActive }) => `${linkClass} ${isActive ? activeClass : ""}`}
      >
        {t("Jobs")}
      </NavLink>
    </div>
  );
};

export default DesktopNav;
